import { request } from '@umijs/max';

// 定义统一的返回结果接口
export interface ResponseStructure<T = any> {
    success: boolean;
    data: T;
    errorCode?: number;
    errorMessage?: string;
    showType?: number;
    traceId?: string;
    host?: string;
}

// API URI constants
export const ADMIN_URI = {
    LOGIN: '/admin/login',
    LOGOUT: '/admin/login/out',
    CURRENT: '/admin/login/current',
    UPDATE_PASSWORD: '/admin/login/update-password',

    UPLOAD: '/admin/upload',

    VOTE_CONFIG: '/admin/vote-config',
    VOTE_CONFIG_UPDATE: '/admin/vote-config/update',
    VOTE_ITEMS: '/admin/vote-items',
    VOTE_ITEMS_CREATE: '/admin/vote-items/create',
    VOTE_ITEMS_UPDATE: '/admin/vote-items/update',
    VOTE_USERS: '/admin/vote-users',
    VOTE_LOGS: '/admin/vote-logs',
} as const;

export async function get<T>(
    uri: string,
    options?: { [key: string]: any },
): Promise<ResponseStructure<T>> {
    return request<ResponseStructure<T>>(uri, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        ...(options || {}),
    });
}

export async function post<TData, TBody>(
    uri: string,
    body: TBody,
    options?: { [key: string]: any },
): Promise<ResponseStructure<TData>> {
    return request<ResponseStructure<TData>>(uri, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    });
}
